import { SolType } from '@sol/components';

export class AsmAssetsType {
  public static readonly hostTechnologyLabel = SolType.ofPrimitive<string>(
    'hostTechnologyLabel',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly domainTechnologyLabel = SolType.ofPrimitive<string>(
    'domainTechnologyLabel',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly websiteTechnologyLabel = SolType.ofPrimitive<string>(
    'websiteTechnologyLabel',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
